"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReitDetails = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("./index.styled"));

var _Tooltip = require("../Tooltip");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ReitDetails = function ReitDetails(_ref) {
  var declaredDividendRateAnnualized = _ref.declaredDividendRateAnnualized,
      distributionFrequency = _ref.distributionFrequency,
      totalAssetValue = _ref.totalAssetValue,
      minimum = _ref.minimum,
      _ref$distributionTool = _ref.distributionTooltip,
      distributionTooltip = _ref$distributionTool === void 0 ? '' : _ref$distributionTool,
      _ref$distributionDisc = _ref.distributionDisclaimer,
      distributionDisclaimer = _ref$distributionDisc === void 0 ? {
    title: 'Distribution Frequency',
    paragraph: 'The frequency with which you can expect to receive distributions. Distributions may be automatically reinvested or deposited to a bank account. Distributions are not guaranteed.'
  } : _ref$distributionDisc;
  return /*#__PURE__*/_react.default.createElement(_index.default.Details, {
    isReit: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "line"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      marginRight: '12px'
    }
  }, "Annualized Distribution Rate"), /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    title: "ANNUALIZED DISTRIBUTION RATE",
    paragraph: distributionTooltip
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "value"
  }, declaredDividendRateAnnualized * 100, "%")), /*#__PURE__*/_react.default.createElement("div", {
    className: "line"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      marginRight: '12px'
    }
  }, "Distribution Frequency"), /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, distributionDisclaimer)), /*#__PURE__*/_react.default.createElement("div", {
    className: "value"
  }, distributionFrequency)), /*#__PURE__*/_react.default.createElement("div", {
    className: "line"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, "Total Asset Value"), /*#__PURE__*/_react.default.createElement("div", {
    className: "value"
  }, "$", totalAssetValue / 1000000, "MM")), /*#__PURE__*/_react.default.createElement("div", {
    className: "line"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, "Minimum Investment"), /*#__PURE__*/_react.default.createElement("div", {
    className: "value"
  }, "$", minimum / 1000, "k")));
};

exports.ReitDetails = ReitDetails;